import React from "react";
import { FaGithubSquare } from "react-icons/fa";
import 'aos/dist/aos.css'; // Pastikan AOS CSS diimpor

export default function Header() {
    return (
        <div className="container mx-auto max-w-[1200px] p-4">
            <div className="flex justify-between items-center">
                <div 
                    className="text-gradient font-secondary"
                    data-aos="fade-right"
                    data-aos-offset="500"
                    data-aos-easing="ease-in-sine"
                    data-aos-delay="0"
                >
                    <a href="/">
                        <h1 className="text-[30px] font-bold leading-none">DARIUS</h1>
                        <h4 className="font-normal leading-none">AMENDA</h4>
                    </a>
                </div>
                <div 
                    className="flex"
                    data-aos="fade-left"
                    data-aos-offset="500"
                    data-aos-easing="ease-in-sine"
                    data-aos-delay="0"
                >
                    <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                        <FaGithubSquare className="text-3xl" />
                    </a>
                </div>
            </div>
        </div>
    );
}
